module.exports = __webpack_public_path__ + "3ede2543b236173bc7e4187ca168b87f.svg";